import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42e897d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e897d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e897d2')) {
      api.createRecord('42e897d2', component.options)
    } else {
      api.reload('42e897d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42e897d2&scoped=true", function () {
      api.rerender('42e897d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/integral/index.vue"
export default component.exports